import { Col, Row } from "antd";
import { useRouteMatch } from "react-router";
import { Box, Flex } from "@chakra-ui/layout";
import { useBreadcrumb } from "features/breadcrumbs";
import { showSuccess } from "infra/helpers/alerta";
import { useState } from "react";
import MenuDetalhes from "components/Menu/MenuDetalhes";
import { TabMenuOptions, TabsMenuOptionsRoutes } from "./typings";
import history from "infra/helpers/history";
import CardDefault from "components/Cards/CardDefault";
import { useLocation } from "react-router-dom";
import PageHeader from "components/Page/PageHeader";
import { BsBank } from "react-icons/bs";
import Container from "components/Container";
import DadosCadastrais from "./components/DadosCadastrais";
import EnderecoCliente from "./components/EnderecoCliente";
import DocumentosCliente from "./components/DocumentosCliente";
import ContratosCliente from "./components/ContratosCliente";

export default function ClientesDetalhesPage() {
  const route = useRouteMatch<{ id: string; tenant: string }>();
  const clienteId = route.params?.id;

  useBreadcrumb([
    { name: "Cadastros", url: "/cadastros" },
    { name: "Clientes", url: "/cadastros/clientes" },
    {
      name: clienteId ? `Editar Cliente` : "Cadastrar Novo Cliente",
    },
  ]);

  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const opcaoParam = !clienteId
    ? TabsMenuOptionsRoutes.Dados
    : (params.get("opcao") as string) || TabsMenuOptionsRoutes.Dados;

  const [selectedMenuOption, setSelectedMenuOption] = useState(opcaoParam);

  const handleChangeMenu = (tab: string) => {
    setSelectedMenuOption(tab);

    if (clienteId) {
      history.push(`/cadastros/clientes/${clienteId}?opcao=${tab}`);
    } else {
      history.push(`/cadastros/clientes/novo?opcao=${tab}`);
    }
  };

  return (
    <Container pb="32px">
      <PageHeader
        title={
          clienteId ? (
            <Flex gap="8px" fontWeight="bold">
              <BsBank />
              Editar Cliente
            </Flex>
          ) : (
            "Cadastrar Novo Cliente"
          )
        }
      />

      <Row gutter={32}>
        <Col sm={6}>
          <Box mb={4} pt="0px" flex={1}>
            <MenuDetalhes<TabsMenuOptionsRoutes>
              disabledOptions={
                !clienteId
                  ? [
                      TabsMenuOptionsRoutes.Endereco,
                      TabsMenuOptionsRoutes.Documentos,
                      TabsMenuOptionsRoutes.Contratos,
                    ]
                  : [TabsMenuOptionsRoutes.Contratos]
              }
              options={TabMenuOptions}
              selectedOption={selectedMenuOption as TabsMenuOptionsRoutes}
              onChangeOption={(tab) => {
                handleChangeMenu(tab);
              }}
            />
          </Box>
        </Col>

        <Col sm={18}>
          {selectedMenuOption === TabsMenuOptionsRoutes.Dados ? (
            <CardDefault>
              <DadosCadastrais
                onSaved={(id) => {
                  showSuccess().then(() => {
                    if (clienteId) {
                      history.push(`/cadastros/clientes/${clienteId}`);
                    } else {
                      history.push(
                        `/cadastros/clientes/${id}?opcao=${TabsMenuOptionsRoutes.Endereco}`
                      );
                    }
                  });
                }}
                id={clienteId}
              />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Endereco &&
          clienteId ? (
            <CardDefault>
              <EnderecoCliente clienteId={clienteId} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Documentos &&
          clienteId ? (
            <CardDefault>
              <DocumentosCliente clienteId={clienteId} />
            </CardDefault>
          ) : null}

          {selectedMenuOption === TabsMenuOptionsRoutes.Contratos &&
          clienteId ? (
            <ContratosCliente />
          ) : null}
        </Col>
      </Row>
    </Container>
  );
}
